import { CreateGUFHeightTask, EditGUFHeightTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGufLibraryFields } from "./guf-schema-library";

const sharedTitle = (type: FormType | undefined) => `GUF Hoogte ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het GUF hoogte formulier. ${getDocsLinkMarkdown("GUF")}`;

const sharedSourcedocumentData = {
  type: "object" as const,
  title: "Brondocumentgegevens",
  required: ["realisedWellId", "height", "startValidity"],
  properties: {
    ...pickGufLibraryFields(["realisedWellId", "height", "wellDepth", "startValidity"]),
    realisedScreens: pickGufLibraryFields(["realisedScreenChanges"]).realisedScreenChanges,
  },
};

const getGufHeightCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<CreateGUFHeightTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: ["projectNumber", "deliveryAccountableParty", "qualityRegime", "broId"],
      properties: pickGufLibraryFields([
        "projectNumber",
        "qualityRegime",
        "deliveryAccountableParty",
        "broId",
      ]),
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

const getGufHeightEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGUFHeightTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: [
        "projectNumber",
        "deliveryAccountableParty",
        "qualityRegime",
        "broId",
        "correctionReason",
      ],
      properties: {
        ...pickGufLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGufLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

export function getGufHeightSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditGUFHeightTask>;
export function getGufHeightSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<CreateGUFHeightTask>;
export function getGufHeightSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}): SchemaForFormData<EditGUFHeightTask> | SchemaForFormData<CreateGUFHeightTask>;
export function getGufHeightSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing ? getGufHeightEditSchema(type) : getGufHeightCreateSchema(type);
}
